// RegisterModel.js
import { postData } from 'src/services/RestApi';

const signUp = async (name, email, phone) => {
  const queryParams = {
    name: name,
    email: email,
    phone: phone,
  };
  const response = await postData('api/signup/', queryParams);
  // Return response or other relevant data if needed
  if (response) {
    return true;
  }
  return false;
};

export { signUp };
